import React from "react";
import CustomAddEditAddress from "../../../../CustomComponents/CustomAddEditAddress";

const AddAddress = () => {
  return (
    <>
      <CustomAddEditAddress headerText="Add Address" buttonText="Save" />
    </>
  );
};

export default AddAddress;
